import { apiClient } from '@/lib/api/client';
import { API_ENDPOINTS } from '@/lib/api/config';
import type {
  BoxType,
  CreateBoxTypeRequest,
  UpdateBoxTypeRequest,
  BoxTypesListParams
} from '../types';

const { BOX_TYPES } = API_ENDPOINTS;

export const boxTypesApi = {
  getAll: (params?: BoxTypesListParams) =>
    apiClient.getPaginated<BoxType>(BOX_TYPES.LIST, params),

  getById: (id: number) => apiClient.get<BoxType>(BOX_TYPES.GET(id)),

  create: (data: CreateBoxTypeRequest) =>
    apiClient.post<BoxType>(BOX_TYPES.CREATE, data),

  update: (id: number, data: UpdateBoxTypeRequest) =>
    apiClient.put<BoxType>(BOX_TYPES.UPDATE(id), data),

  delete: ({ id, force }: { id: number; force?: boolean }) =>
    apiClient.delete(BOX_TYPES.DELETE(id) + (force ? '?force=true' : '')),

  bulkDelete: (
    params:
      | { ids: number[] }
      | { all: true; filters: Partial<BoxTypesListParams> }
  ) => apiClient.post(BOX_TYPES.BULK_DELETE, params),

  bulkChangeStatus: (
    params:
      | { ids: number[]; status: 'active' | 'inactive' }
      | {
          all: true;
          filters: Partial<BoxTypesListParams>;
          status: 'active' | 'inactive';
        }
  ) => apiClient.post(BOX_TYPES.BULK_CHANGE_STATUS, params)
};
